class PopinPlayer
{
  constructor()
  {

    this.container = document.body.querySelector('.Popin_playerC')
    if( !this.container ) return
    this.player = this.container.querySelector('.Popin_player')
    this.items = document.body.querySelectorAll('[data-video]')

    this.openPopin = this.openPopin.bind(this)
    this.closePopin = this.closePopin.bind(this)

    this.init()
  }

  init()
  {
    for (let i = 0; i < this.items.length; i++) {
      let element = this.items[i];
      element.addEventListener('click', this.openPopin )
    }

    this.container.querySelector('.Popin_close').addEventListener('click', this.closePopin )
    this.container.querySelector('.Popin_cache').addEventListener('click', this.closePopin )
  }

  closePopin()
  {
    document.body.style.overflow = "auto"

    this.container.classList.remove('is-open')

    this.player.innerHTML = ''
  }

  openPopin(e)
  {
    e.preventDefault();

    let el = e.currentTarget;

    this.videoLink = el.getAttribute('data-video')

    if(!this.videoLink) return

    document.body.style.overflow = "hidden"

    if(el.classList.contains('intern'))
    {
      this.player.innerHTML = `<video src="` + this.videoLink + `" autoplay controls></video>`
    }
    else
    {
      this.player.innerHTML = this.videoLink
    }

    this.container.classList.add('is-open')
  }
}

export default PopinPlayer;


// WEBPACK FOOTER //
// ./src/js/partials/PopinPlayer.js